'use strict';

var React = require('react');

var SvgUnfulfilledMajor = function SvgUnfulfilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 3v11h3.5c.775 0 1.388.662 1.926 1.244l.11.12a2 2 0 0 0 2.927-.001l.111-.119c.538-.582 1.151-1.244 1.926-1.244h3.5v-11h-14zm3-2h-3.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5h-11.5z"
  }));
};

exports.SvgUnfulfilledMajor = SvgUnfulfilledMajor;
